import React from 'react';

export class FormField extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get type () {
    var type = 'text';
    if (this.props.field.options && this.props.field.options.indexOf('#') > -1) type = 'checkbox';
    if (this.props.field.options && this.props.field.options.indexOf('#') === -1) type = 'radio';
    return type;
  }

  get options () {
    var options = this.props.field.options.split('\n');
    return options.map(option => option.replace('# ', '').replace('#', '').replace('- ', '').replace('-', ''));
  }

  render () {
    return (
      <div className="form-field">
        <label className="form-field__label">— { this.props.field.title }</label>
        { this.type === 'text' && this.renderTextfield() }
        { this.type === 'checkbox' && this.renderCheckbox() }
        { this.type === 'radio' && this.renderRadio() }
      </div>
    );
  }

  renderTextfield () {
    return (
      <input type="text" name={this.props.field.name} className="form-field__text" />
    );
  }

  renderCheckbox () {
    return (
      <div className="form-field__checkboxes">
        { this.options.map(option => (
          <div className="form-field__checkbox">
            <input type="checkbox" value={option} name={this.props.field.name} /> { option }
          </div>
        ))}
      </div>
    );
  }

  renderRadio () {
    return (
      <div className="form-field__radios">
        { this.options.map(option => (
          <div className="form-field__radio">
            <input type="radio" value={option} name={this.props.field.name} /> { option }
          </div>
        ))}
      </div>
    );
  }
}
